/**
 * Address Validation Service
 *
 * Client-side service to call backend address validation API
 * (which uses SmartyStreets for USPS address standardization)
 */

import { api } from "../lib";

export interface AddressInput {
  address: string;
  city: string;
  state: string;
  zipCode?: string;
}

export interface ValidatedAddress extends AddressInput {
  isValid: boolean;
  deliveryLineOne?: string;
  lastLine?: string;
  county?: string;
  latitude?: number;
  longitude?: number;
  precision?: string;
  validationMessage?: string;
}

/**
 * Validate an address using SmartyStreets API (via backend)
 *
 * @param address - Address to validate
 * @returns ValidatedAddress with corrected/standardized fields
 */
export const validateAddress = async (
  address: AddressInput
): Promise<ValidatedAddress> => {
  return api.post<ValidatedAddress>("/reference/address/validate", address);
};

/**
 * Check if address validation service is available
 *
 * @returns boolean indicating if the service is configured
 */
export const isAddressValidationAvailable = async (): Promise<boolean> => {
  const response = await api.get<{ available: boolean }>(
    "/reference/address/validation-available"
  );
  return response.available;
};
